import { motion } from "motion/react";
import { site } from "../../data/site";

interface LoadingScreenProps {
  variant?: "fullscreen" | "section";
}

export function LoadingScreen({ variant = "fullscreen" }: LoadingScreenProps) {
  const isFullscreen = variant === "fullscreen";

  return (
    <div
      aria-busy="true"
      aria-live="polite"
      role="status"
      className={
        isFullscreen
          ? "grid min-h-screen place-items-center bg-stratify-ink text-stratify-white"
          : "grid min-h-[70vh] place-items-center bg-stratify-paper text-stratify-ink"
      }
    >
      <span className="sr-only">Loading Stratify</span>
      <div className="relative h-28 w-28">
        {[0, 0.45, 0.9].map((delay) => (
          <motion.span
            key={delay}
            aria-hidden="true"
            className={`absolute inset-0 rounded-full border ${isFullscreen ? "border-stratify-mint/35" : "border-stratify-emerald/35"}`}
            initial={{ opacity: 0, scale: 0.62 }}
            animate={{ opacity: [0, 0.72, 0], scale: [0.62, 1.08, 1.52] }}
            transition={{ duration: 1.9, repeat: Infinity, ease: "easeOut", delay }}
          />
        ))}

        <motion.div
          aria-hidden="true"
          className={`absolute inset-6 rounded-full ${isFullscreen ? "bg-white/8 shadow-[0_0_36px_rgba(114,230,197,0.22)]" : "bg-stratify-mist shadow-soft"}`}
          animate={{ scale: [0.94, 1.03, 0.94] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
        />

        <motion.img
          src={site.appIcon}
          alt=""
          className="absolute inset-9 h-10 w-10 rounded-xl"
          animate={{ scale: [0.96, 1.04, 0.96], opacity: [0.78, 1, 0.78] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
    </div>
  );
}
